import { handleErrorApi } from '@/shared/lib';
import { createClient } from '@/shared/api';
import type { TicketCommentsQuery, TicketCommentsQueryVariables } from '@/shared/api';
import TICKET_COMMENTS_QUERY from '../queries/ticketComments';

/**
 * Loads a page of comments for a support ticket. Queries TICKET_COMMENTS_QUERY with the filter and optional limit and unwraps the ticketComments field through the shared error handler.
 *
 * @param filter - Filter criteria identifying the ticket whose comments are loaded.
 * @param limit - Maximum number of comments to return.
 * @returns Promise resolving to the ticket comments.
 */
const fetchTicketComments = async (
  filter: TicketCommentsQueryVariables['filter'],
  limit?: number,
): Promise<TicketCommentsQuery['ticketComments']> => {
  const client = createClient();
  const result = await client.query<TicketCommentsQuery, TicketCommentsQueryVariables>({
    query: TICKET_COMMENTS_QUERY,
    variables: {
      filter,
      limit,
    },
  });
  return handleErrorApi(result, 'ticketComments');
};

export default fetchTicketComments;
